import { Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { AuthModule } from '../auth/auth.module';
import { InvoicesModule } from '../invoices/invoices.module';
import { CartModule } from '../cart/cart.module';
import { NotificationsModule } from '../notifications/notifications.module';
import { AdminOrdersController, OrdersController } from './orders.controller';
import { OrdersRepository, PrismaOrdersRepository } from './orders.repository';
import { OrdersService } from './orders.service';

@Module({
  imports: [AuthModule, CartModule, NotificationsModule, InvoicesModule],
  controllers: [OrdersController, AdminOrdersController],
  providers: [
    OrdersService,
    PrismaService,
    {
      provide: OrdersRepository,
      useClass: PrismaOrdersRepository,
    },
  ],
  exports: [OrdersRepository],
})
export class OrdersModule {}
